var exports = {
  "K": "RecentMentionsPage.module__icon___RXdCNG",
};

module.exports = exports;
